import { Component, OnInit } from '@angular/core';

import { Deslocamento } from "../shared/deslocamento.model";
import { deslocamentosModuleName, tiposDeslocamentos, statusDeslocamentos } from "../shared/data.service";
import { DeslocamentoApiService } from "../shared/deslocamento-api.service";
import { UtilService } from "../../../shared/services/util.service";
import {DeslocamentoService} from "../shared/deslocamento.service";
import {FuncionarioService} from "../../../recursos-humanos/funcionarios/funcionario.service";
import {funcionariosQueryComPessoa} from "../../../recursos-humanos/funcionarios/data.service";
import {FuncionarioApiService} from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {viagensModuleName} from "../../shared/data.service";
import {destinosQuery} from "../../destinos/shared/data.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {MotoristaApiService} from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import {MotoristaService} from "../../../recursos-humanos/motoristas/shared/motorista.service";
import {DestinoApiService} from "../../destinos/shared/destino-api.service";
import {motoristasQuery} from "../../../recursos-humanos/motoristas/shared/data.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";

@Component({
    template: require('./deslocamento-history.component.html'),
    styles: [require('./deslocamento-history.component.css')]
})
export class DeslocamentoHistoryComponent implements OnInit {
    list: Deslocamento[] = [];
    loading: boolean = false;
    showDisabled: boolean = false;
    deslocamentosModuleName: any = deslocamentosModuleName;
    module: any = viagensModuleName;
    researched: boolean = false;

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};

    funcionarioSearch: any = {};
    funcionarioSelectId: string = 'funcionario';
    funcionarioQuery: any = {};
    tipoSearch: any = {};
    tiposList: any[] = [];
    statusSearch: any = {};
    statusList: any[] = [];
    dataInicialSearch: any;
    dataFinalSearch: any;
    numeroRequisicaoSearch: string;
    destinoSearch: any = {};
    destinoSelectId: string = 'destino';
    destinoQuery: any = {};
    passageiroNomeSearch: string;
    passageiroCpfSearch: string;
    frotaSearch: any = {};
    frotaSelectId: string = 'frota';
    frotaQuery: any = {};
    motoristaSearch: any = {};
    motoristaSelectId: string = 'motorista';
    motoristaQuery: any = {};

    constructor(
        private _deslocamentosApiService: DeslocamentoApiService,
        private _deslocamentoService: DeslocamentoService,
        private _utilService: UtilService,

        private _funcionarioService: FuncionarioService,
        private _funcionarioApiService: FuncionarioApiService,
        private _destinoApiService: DestinoApiService,
        private _frotaService: FrotasService,
        private _frotaApiService: FrotaApiService,
        private _frotaNavigationService: FrotaNavigationService,
        private _motoristaApiService: MotoristaApiService,
        private _motoristaService: MotoristaService,
        private _autocompleteService: AutoCompleteService
    ) { }

    ngOnInit() {
        this.funcionarioQuery = this._utilService.cloneObject(funcionariosQueryComPessoa);
        this.destinoQuery = this._utilService.cloneObject(destinosQuery);
        this.motoristaQuery = this._utilService.cloneObject(motoristasQuery);
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);

        this.getTipos();
        this.getStatus();
        this.clickClearSearch();

        let datePicker: any = $('.input-datepicker');
        const t: any = this;
        datePicker.datepicker({
            onSelect: function(e: any) {
                t.changeData();
            }
        });

        this.testFrotaBackHistory();
    }

    changeData() {
        this.list = [];
        this.queryMovimentacoes();
    }

    changeTipo() {
        this.queryMovimentacoes();
    }

    changeStatus() {
        this.queryMovimentacoes();
    }

    keyupPassageiro(e: any) {
        if (e.keyCode === 13) {
            this.queryMovimentacoes();
        }
    }

    clickClearSearch() {
        this.tipoSearch = this.tiposList[0];
        this.statusSearch = this.statusList[0];

        this.funcionarioSearch = {};
        this.frotaSearch = {};
        this.destinoSearch = {};
        this.motoristaSearch = {};

        this.numeroRequisicaoSearch = '';
        this.passageiroNomeSearch = '';
        this.passageiroCpfSearch = '';

        let date:any = document.getElementById('data_inicial');
        date.value = null;
        date = document.getElementById('data_final');
        date.value = null;

        this._autocompleteService.setValueOnSelect2(null, "funcionario");
        this._autocompleteService.setValueOnSelect2(null, "frota");
        this._autocompleteService.setValueOnSelect2(null, "motorista");
        this._autocompleteService.setValueOnSelect2(null, "destino");

        this.list = [];
    }

    clickGoToFrotaDetail() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    getDestinoObject(object: any) {
        this.destinoSearch = object;
        this.queryMovimentacoes();
    }

    getFuncionarioObject(object: any) {
        this.funcionarioSearch = object;
        this.queryMovimentacoes();
    }

    funcionarioTemplateResult = (function(state: any) {
        let template: any = this._funcionarioService.templateResult(state, false);
        return template;
    }.bind(this));

    getFrotaObject(object: any) {
        this.frotaSearch = object;
        this.queryMovimentacoes();
    }

    frotaTemplateResult = (function(state: any) {
        let template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    getMotoristaObject(object: any) {
        this.motoristaSearch = object;
        this.queryMovimentacoes();
    }

    motoristaTemplateResult = (function(state: any) {
        let template: any = this._motoristaService.templateResult(state, false);
        return template;
    }.bind(this));

    private queryMovimentacoes() {
        let query: any = {},
            queryDateStart: any, queryDateEnd: any;

        let dateStart: any = document.getElementById('data_inicial');
        if (dateStart.value) {
            const currDate = this._utilService.convertStringToDate(dateStart.value);
            let nextCurrDate = new Date(currDate.getTime());
            nextCurrDate.setDate(currDate.getDate() + 1);
            queryDateStart = {dataHoraPrevistaSaida: {"gt": currDate}};
        }

        let dateEnd: any = document.getElementById('data_final');
        if (dateEnd.value) {
            const currDate = this._utilService.convertStringToDate(dateEnd.value);
            let nextCurrDate = new Date(currDate.getTime());
            nextCurrDate.setDate(currDate.getDate() + 1);
            queryDateEnd = {dataHoraPrevistaSaida: {"lt": nextCurrDate}};
        }

        if (dateEnd.value && dateStart.value) {
            query.and = [queryDateStart, queryDateEnd];
        } else if (dateEnd.value && !dateStart.value) {
            query.and = [queryDateEnd];
        } else if (dateStart.value && !dateEnd.value) {
            query.and = [queryDateStart];
        }

        if (this.tipoSearch.Key) {
            query.tipo = this.tipoSearch.Key;
        }

        if (this.statusSearch.Key) {
            if (this.statusSearch.Key === -1) {
                const statusAprovado = this._deslocamentoService.getStatusAprovado();
                const statusSolicitado = this._deslocamentoService.getStatusSolicitado();
                const or = {or: [{status: statusAprovado}, {status: statusSolicitado}]};
                if (query.and) {
                    query.and.push(or);
                } else {
                    query.and = [or];
                }
            } else {
                query.status = this.statusSearch.Key;
            }
        }

        if (this.funcionarioSearch.id) {
            query.solicitanteId = this.funcionarioSearch.id;
        }

        if (this.destinoSearch.id) {
            query.destinoId = this.destinoSearch.id;
        }

        if (this.motoristaSearch.id) {
            query.motoristaDesignadoId  = this.motoristaSearch.id;
        }

        if (this.frotaSearch.id) {
            query.bemId = this.frotaSearch.id;
        }

        if (this.numeroRequisicaoSearch) {
            query.numeroRequisicao = this.numeroRequisicaoSearch;
        }

        if (this.passageiroCpfSearch) {
            let cpf = this.passageiroCpfSearch;
            cpf = this._utilService.removeSpecialCharacter(cpf);
            query.cpfPassageiro = cpf;
        }

        if (this.passageiroNomeSearch) {
            query.nomePassageiro = this.passageiroNomeSearch;
        }

        this.getMovimentacoes(query);
    }

    private getMovimentacoes(query: any) {
        this.loading = true;
        this._deslocamentosApiService.onGetByPassageiro(query, this.onDone);
    }

    private onDone = (function(Response: any) {
        if (!Response.error)  {
            let x: number, lenX: number;
            for (x = 0, lenX = Response.length; x < lenX; x++) {
                Response[x].tipo = this._deslocamentoService.getTipo(Response[x].tipo);
                Response[x].status = this._deslocamentoService.getStatus(Response[x].status);
            }

            this.list = Response;
        }
        this.loading = false;
        this.researched = true;
    }.bind(this));

    private getStatus() {
        let list: any[] = this._utilService.cloneObject(statusDeslocamentos);
        let statusAprovado: any = this._deslocamentoService.getStatusAprovado();
        let statusSolicitado: any = this._deslocamentoService.getStatusSolicitado();

        statusAprovado = this._deslocamentoService.getStatus(statusAprovado);
        statusSolicitado = this._deslocamentoService.getStatus(statusSolicitado);

        list.unshift({Key: -1, Value: 'Ativos ('+ statusAprovado.Value + ' e '+ statusSolicitado.Value + ')'});
        list.unshift({Key: null, Value: '— Status —'});
        this.statusList = list;
        this.statusSearch = this.statusList[0];
    }

    private getTipos() {
        let list: any[] = this._utilService.cloneObject(tiposDeslocamentos);
        list.unshift({Key: null, Value: '— Tipo —'});
        this.tiposList = list;
        this.tipoSearch = this.tiposList[0];
    }

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory('frota');

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

        if (this.showFrotaLink) {
            this.getFrotaObject(this.frotaDetailHistory);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamento-history/deslocamento-history.component.ts
 **/